import { PersonLogin } from "../person/person-login";
import { FpaCostBasis } from "./fpa-cost-basis";

export class FpaTaskResponse {
  taskId!: number;
  responder!: PersonLogin;
  additionalData!: string;
  approved!: boolean;
  requestedMultiplier!: number;
  comments!: string;
  costBasis!: FpaCostBasis;
}
